import { useMemo, useState } from "react";
import { addDays, differenceInCalendarDays, format, parseISO, startOfDay } from "date-fns";

export const iso = (d) => format(d, "yyyy-MM-dd");

export function useBooking(prop, blocked) {
  const [range, setRange] = useState({ from: undefined, to: undefined });
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);

  const blockedSet = useMemo(() => {
    const s = new Set();
    (Array.isArray(blocked) ? blocked : []).forEach((r) => {
      let d = parseISO(r.start);
      const end = parseISO(r.end);
      for (let i = 0; d < end && i < 800; i++) {
        s.add(iso(d));
        d = addDays(d, 1);
      }
    });
    return s;
  }, [blocked]);

  const disabled = useMemo(() => {
    const today = startOfDay(new Date());
    if (range.from && !range.to) {
      let fb = null;
      let d = range.from;
      for (let i = 0; i < 500; i++) {
        if (blockedSet.has(iso(d))) { fb = d; break; }
        d = addDays(d, 1);
      }
      return fb ? [{ before: range.from }, { after: fb }] : [{ before: range.from }];
    }
    return [{ before: today }, (day) => blockedSet.has(iso(day))];
  }, [range, blockedSet]);

  const onSelect = (_r, day) => {
    if (!day) return;
    if (!range.from || range.to || day <= range.from) {
      if (!blockedSet.has(iso(day))) setRange({ from: day, to: undefined });
      return;
    }
    setRange({ from: range.from, to: day });
  };

  const nights = range.from && range.to ? differenceInCalendarDays(range.to, range.from) : 0;
  const price = Number(prop?.price_per_night ?? 0);
  const cleaning = Number(prop?.cleaning_fee ?? 0);
  const subtotal = nights * price;
  const total = nights ? subtotal + cleaning : 0;
  const minNights = Number(prop?.min_nights ?? 1);
  const maxGuests = Number(prop?.max_guests ?? 4);
  const ready = nights >= Math.max(1, minNights);

  return {
    range, setRange, onSelect, disabled, adults, setAdults, children, setChildren,
    nights, price, cleaning, subtotal, total, minNights, maxGuests, ready,
    clear: () => setRange({ from: undefined, to: undefined }),
  };
}

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
